<template>
  <div class="article-manage">
    <div class="page-header">
      <h2>私人订制</h2>
      <div>
        <el-button
          v-if="multipleSelection.length > 0"
          type="danger"
          icon="el-icon-delete"
          @click="handleBatchDelete"
        >
          批量删除 ({{ multipleSelection.length }})
        </el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
          添加文章
        </el-button>
      </div>
    </div>

    <!-- 搜索栏 -->
    <div class="search-section">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="文章标题">
          <el-input
            v-model="searchForm.title"
            placeholder="请输入文章标题"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="上下架状态">
          <el-select
            v-model="searchForm.validation"
            placeholder="请选择状态"
            clearable
            style="width: 150px"
          >
            <el-option label="全部" :value="null" />
            <el-option label="下架" :value="0" />
            <el-option label="上架" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 380px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <el-table
        v-loading="loading"
        :data="articleList"
        border
        stripe
        style="width: 100%"
        empty-text="暂无数据"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        <el-table-column
          label="序号"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            {{ (pagination.current - 1) * pagination.size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="文章标题"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          label="文章内容"
          min-width="250"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.content"
              placement="top"
              width="400"
              trigger="hover"
            >
              <p style="white-space: pre-wrap; max-height: 300px; overflow-y: auto;">{{ scope.row.content }}</p>
              <span slot="reference" class="content-text">
                {{ scope.row.content.length > 50 ? scope.row.content.substring(0, 50) + '...' : scope.row.content }}
              </span>
            </el-popover>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="图片"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.images && scope.row.images.length > 0" class="image-preview">
              <el-image
                :src="scope.row.images[0]"
                :preview-src-list="scope.row.images"
                fit="cover"
                style="width: 80px; height: 80px; cursor: pointer;"
                @error="handleImageError"
              />
              <span v-if="scope.row.images.length > 1" class="image-count">+{{ scope.row.images.length - 1 }}</span>
            </div>
            <span v-else class="no-image">无图片</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contactName"
          label="联系人姓名"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.contactName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contactPhone"
          label="联系电话"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.contactPhone || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contactEmail"
          label="联系邮箱"
          width="180"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.contactEmail || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="上下架状态"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="getValidationType(scope.row.validation)">
              {{ getValidationText(scope.row.validation) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="300"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="operation-buttons">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                v-if="scope.row.validation === 0 || scope.row.validation === false"
                type="success"
                size="mini"
                icon="el-icon-top"
                @click="handleOnline(scope.row)"
              >
                上架
              </el-button>
              <el-button
                v-else
                type="warning"
                size="mini"
                icon="el-icon-bottom"
                @click="handleOffline(scope.row)"
              >
                下架
              </el-button>
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        v-if="pagination.total > 0"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        ref="articleForm"
        :model="articleForm"
        :rules="formRules"
        label-width="120px"
      >
        <el-form-item label="文章标题" prop="title">
          <el-input
            v-model="articleForm.title"
            placeholder="请输入文章标题"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <el-input
            v-model="articleForm.content"
            type="textarea"
            :rows="6"
            placeholder="请输入文章内容"
            maxlength="5000"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="图片列表" prop="images">
          <div class="images-upload-section">
            <el-upload
              class="images-uploader"
              :action="''"
              :file-list="imageList"
              :auto-upload="false"
              :on-remove="handleRemoveImage"
              :on-change="handleImageChange"
              :before-upload="beforeImageUpload"
              list-type="picture-card"
              accept="image/*"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="image-tips">
              <p>支持多图上传，单张图片不超过10MB</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="contactName">
          <el-input
            v-model="articleForm.contactName"
            placeholder="请输入联系人姓名（可选）"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
            v-model="articleForm.contactPhone"
            placeholder="请输入联系电话（可选）"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contactEmail">
          <el-input
            v-model="articleForm.contactEmail"
            placeholder="请输入联系邮箱（可选）"
            maxlength="100"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getArticleList, createArticle, getArticleDetail, updateArticle, deleteArticle, batchDeleteArticles, onlineArticle, offlineArticle } from '@/api/article'
import { uploadImages } from '@/api/cos'
import { formatDate, getDefaultImagePlaceholder } from '@/utils/index'
import { ARTICLE_VALIDATION_TEXT, ARTICLE_VALIDATION_TYPE } from '@/utils/constants'
import { handleApiError } from '@/utils/errorHandler'

export default {
  name: 'ArticleManage',
  data() {
    // 邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        if (emailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入有效的邮箱地址'))
        }
      }
    }

    return {
      loading: false,
      submitLoading: false,
      articleList: [],
      multipleSelection: [],
      searchForm: {
        title: '',
        validation: null
      },
      dateRange: null,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '添加文章',
      isEdit: false,
      articleForm: {
        id: '',
        title: '',
        content: '',
        images: [],
        contactName: '',
        contactPhone: '',
        contactEmail: ''
      },
      formRules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' }
        ],
        contactEmail: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      },
      imageList: [],
      uploadedImageUrls: []
    }
  },
  mounted() {
    this.loadArticleList()
  },
  methods: {
    // 加载文章列表
    async loadArticleList() {
      this.loading = true
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          title: this.searchForm.title,
          validation: this.searchForm.validation,
          // 默认按创建时间倒序排序
          sortItemList: [
            {
              isAsc: false,
              column: 'createTime'
            }
          ]
        }
        
        // 处理时间范围
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        
        const response = await getArticleList(params)
        if (response.data && response.data.success) {
          // 处理返回的数据结构，将contactInfo展开，并处理validation布尔值
          const records = (response.data.data.records || []).map(record => {
            const processed = { ...record }
            // 如果contactInfo存在，将其字段展开到记录中
            if (record.contactInfo) {
              processed.contactName = record.contactInfo.contactName || ''
              processed.contactPhone = record.contactInfo.contactPhone || ''
              processed.contactEmail = record.contactInfo.contactEmail || ''
            }
            // 处理validation布尔值，转换为数字（false -> 0, true -> 1）
            if (typeof processed.validation === 'boolean') {
              processed.validation = processed.validation ? 1 : 0
            }
            return processed
          })
          this.articleList = records
          this.pagination.total = response.data.data.total || 0
        } else {
          this.$message.error(response.data?.message || '获取文章列表失败')
        }
      } catch (error) {
        handleApiError(error, '加载文章列表失败', { showMessage: true })
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadArticleList()
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        title: '',
        validation: null
      }
      this.dateRange = null
      this.pagination.current = 1
      this.loadArticleList()
    },
    
    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.loadArticleList()
    },
    
    // 当前页改变
    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadArticleList()
    },
    
    // 格式化日期 - 使用工具函数
    formatDate,
    
    // 获取审核状态文本
    getAuditStatusText(status) {
      const statusMap = {
        0: '审核失败',
        10: '审核成功'
      }
      return statusMap[status] || '未知'
    },
    
    // 获取审核状态类型（用于标签颜色）
    getAuditStatusType(status) {
      const typeMap = {
        0: 'danger',
        10: 'success'
      }
      return typeMap[status] || ''
    },
    
    // 获取上下架状态文本
    getValidationText(validation) {
      return ARTICLE_VALIDATION_TEXT[validation] || '未知'
    },
    
    // 获取上下架状态类型（用于标签颜色）
    getValidationType(validation) {
      return ARTICLE_VALIDATION_TYPE[validation] || ''
    },
    
    // 图片加载错误处理
    handleImageError(e) {
      e.target.src = getDefaultImagePlaceholder()
    },
    
    // 选择变化
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    
    // 添加文章
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '添加文章'
      this.resetForm()
      this.dialogVisible = true
    },
    
    // 编辑文章
    async handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑文章'
      this.loading = true
      try {
        // 文章ID可能是字符串或数字，统一转换为字符串
        const articleId = String(row.id)
        const response = await getArticleDetail(articleId)
        if (response.data && response.data.success) {
          const article = response.data.data
          // 处理contactInfo对象
          const contactInfo = article.contactInfo || {}
          this.articleForm = {
            id: article.id,
            title: article.title || '',
            content: article.content || '',
            images: article.images || [],
            contactName: article.contactName || contactInfo.contactName || '',
            contactPhone: article.contactPhone || contactInfo.contactPhone || '',
            contactEmail: article.contactEmail || contactInfo.contactEmail || ''
          }
          
          // 设置图片列表
          this.uploadedImageUrls = article.images || []
          this.imageList = (article.images || []).map((url, index) => ({
            uid: index,
            name: `图片${index + 1}`,
            url: url,
            status: 'success'
          }))
          
          this.dialogVisible = true
        } else {
          this.$message.error(response.data?.message || '获取文章详情失败')
        }
      } catch (error) {
        handleApiError(error, '加载文章详情失败', { showMessage: true })
      } finally {
        this.loading = false
      }
    },
    
    // 删除文章
    handleDelete(row) {
      this.$confirm('确定要删除该文章吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const articleId = String(row.id)
          const response = await deleteArticle(articleId)
          if (response.data && response.data.success) {
            this.$message.success('删除成功')
            this.loadArticleList()
          } else {
            this.$message.error(response.data?.message || '删除失败')
          }
        } catch (error) {
          handleApiError(error, '删除失败', { showMessage: true })
        }
      }).catch(() => {})
    },
    
    // 批量删除
    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的文章')
        return
      }
      
      this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 篇文章吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const ids = this.multipleSelection.map(item => String(item.id))
          const response = await batchDeleteArticles(ids)
          if (response.data && response.data.success) {
            this.$message.success('批量删除成功')
            this.multipleSelection = []
            this.loadArticleList()
          } else {
            this.$message.error(response.data?.message || '批量删除失败')
          }
        } catch (error) {
          handleApiError(error, '批量删除失败', { showMessage: true })
        }
      }).catch(() => {})
    },
    
    // 上架文章
    handleOnline(row) {
      this.$confirm('确定要上架该文章吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const articleId = String(row.id)
          const response = await onlineArticle(articleId)
          if (response.data && response.data.success) {
            this.$message.success('上架成功')
            this.loadArticleList()
          } else {
            this.$message.error(response.data?.message || '上架失败')
          }
        } catch (error) {
          handleApiError(error, '上架失败', { showMessage: true })
        }
      }).catch(() => {})
    },
    
    // 下架文章
    handleOffline(row) {
      this.$confirm('确定要下架该文章吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const articleId = String(row.id)
          const response = await offlineArticle(articleId)
          if (response.data && response.data.success) {
            this.$message.success('下架成功')
            this.loadArticleList()
          } else {
            this.$message.error(response.data?.message || '下架失败')
          }
        } catch (error) {
          handleApiError(error, '下架失败', { showMessage: true })
        }
      }).catch(() => {})
    },
    
    // 图片上传前的验证
    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      
      if (!isImage) {
        this.$message.error('只能上传图片文件！')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过10MB！')
        return false
      }
      return false // 阻止自动上传
    },
    
    // 图片变化处理
    handleImageChange(file, fileList) {
      this.imageList = fileList
    },
    
    // 移除图片
    handleRemoveImage(file, fileList) {
      this.imageList = fileList
      // 从已上传的URL列表中移除
      if (file.url && this.uploadedImageUrls.includes(file.url)) {
        this.uploadedImageUrls = this.uploadedImageUrls.filter(url => url !== file.url)
      }
    },
    
    // 上传图片到COS
    async uploadImagesToCOS() {
      const filesToUpload = this.imageList
        .filter(file => file.raw || file.status === 'ready')
        .map(file => file.raw || file)
      
      if (filesToUpload.length === 0) {
        return this.uploadedImageUrls
      }
      
      try {
        const urls = await uploadImages(filesToUpload)
        this.uploadedImageUrls = [...this.uploadedImageUrls, ...urls]
        return this.uploadedImageUrls
      } catch (error) {
        const errorMsg = handleApiError(error, '图片上传失败', { showMessage: false })
        throw new Error(errorMsg)
      }
    },
    
    // 提交表单
    async handleSubmit() {
      this.$refs.articleForm.validate(async (valid) => {
        if (!valid) {
          return false
        }
        
        this.submitLoading = true
        try {
          // 上传图片
          const imageUrls = await this.uploadImagesToCOS()
          
          // 如果没有新上传的图片但有已存在的图片（编辑模式）
          if (imageUrls.length === 0 && this.imageList.length > 0) {
            imageUrls.push(...this.imageList.map(f => f.url).filter(url => url))
          }
          
          // 准备提交数据
          const submitData = {
            title: this.articleForm.title,
            content: this.articleForm.content,
            images: imageUrls,
            contactName: this.articleForm.contactName || undefined,
            contactPhone: this.articleForm.contactPhone || undefined,
            contactEmail: this.articleForm.contactEmail || undefined
          }
          
          let response
          if (this.isEdit) {
            submitData.id = String(this.articleForm.id)
            response = await updateArticle(submitData)
          } else {
            response = await createArticle(submitData)
          }
          
          if (response.data && response.data.success) {
            this.$message.success(this.isEdit ? '更新成功' : '创建成功')
            this.dialogVisible = false
            this.loadArticleList()
          } else {
            this.$message.error(response.data?.message || (this.isEdit ? '更新失败' : '创建失败'))
          }
        } catch (error) {
          handleApiError(error, '提交失败', { showMessage: true })
        } finally {
          this.submitLoading = false
        }
      })
    },
    
    // 重置表单
    resetForm() {
      this.articleForm = {
        id: '',
        title: '',
        content: '',
        images: [],
        contactName: '',
        contactPhone: '',
        contactEmail: ''
      }
      this.imageList = []
      this.uploadedImageUrls = []
      if (this.$refs.articleForm) {
        this.$refs.articleForm.clearValidate()
      }
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.resetForm()
    }
  }
}
</script>

<style scoped>
.article-manage {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.page-header > div {
  display: flex;
  gap: 10px;
}

.search-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.table-container {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.image-preview {
  position: relative;
  display: inline-block;
}

.image-count {
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 2px;
}

.no-image {
  color: #999;
  font-size: 12px;
}

.content-text {
  cursor: pointer;
  color: #303133;
}

.operation-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
}

.images-upload-section {
  width: 100%;
}

.images-uploader {
  margin-bottom: 10px;
}

.image-tips {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.image-tips p {
  margin: 5px 0;
}

.dialog-footer {
  text-align: right;
}
</style>
